import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule, PageSlotModule } from '@spartacus/storefront';
import { KbCustomerIdDropdownModule } from './customer-id-drop-down/customer-id-drop-down.module';
import { KbMyOwnPartnumbersComponent } from './kb-my-own-partnumbers/kb-my-own-partnumbers.component';
import { CustomerIdDropDownComponent } from './customer-id-drop-down/customer-id-drop-down.component';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { OwnPartsPopupComponent } from './own-parts-popup/own-parts-popup.component';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';

@NgModule({
  declarations: [KbMyOwnPartnumbersComponent, OwnPartsPopupComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MediaModule,
    KbMyAccountLeftSideNavModule,
    FormsModule,
    KbCustomerIdDropdownModule,
    KbPipesModule,
    PageSlotModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyOwnPartFlexComponent: {
          component: KbMyOwnPartnumbersComponent,
          guards: [SecureGuard, AuthGuard]
        },
      },
    } as CmsConfig),
  ],
  exports: [CustomerIdDropDownComponent],
})
export class KbMyOwnPartNumbersModule { }
